import { Injectable } from "@angular/core";
import { IxellAPIService } from "./api.service";
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { HeaderService } from './header.service';
import { Roles } from './api.service';

@Injectable()
export class LogInService {
    apiSub: any;
    firstTime: boolean = false;

    constructor(private storageService: StorageService, private router: Router, private headerService: HeaderService) {
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * parseToken
     * @param token
     * @returns boolean
     */
    parseToken(token: string) : boolean {
        this.storageService.set("tokenOAuth", token);
        this.storageService.set("token", token);
        return true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * haveTokenOAuth
     * @returns boolean
     */
    haveTokenOAuth() : boolean {
        var token = this.storageService.get("tokenOAuth");
        if (token && token != undefined && token != null && token != "") {
            return true;
        }
        return false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * haveToken
     * @param token
     * @returns
     */
    haveToken(): boolean {
        var token = this.storageService.get("token");
        if (token && token != undefined && token != null && token != "" && token != "temp") {
            return true;
        }
        return false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * tokenAndTokenOAuthDifferent
     * @returns boolean
     */
    tokenAndTokenOAuthDifferent(): boolean {
        return this.storageService.get("tokenOAuth") != this.storageService.get("tokenOAuth");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * tokenEgalTokenOAuth
     * @returns boolean
     */
    tokenEgalTokenOAuth(): Boolean {
        return this.storageService.get("tokenOAuth") == this.storageService.get("tokenOAuth");
    }

    //parseTokenOAuth(data: any): boolean {
    //    if (data.status == 200) {
    //        this.storageService.set("token", "temp");
    //        const reader = new FileReader();
    //        // This fires after the blob has been read/loaded.
    //        reader.addEventListener('loadend', (e) => {
    //            var elem = (<any>e.srcElement);
    //            if (elem == null) {
    //                // Pour la version ESR de Firefox
    //                elem = (<any>e.target);
    //            }
    //            const text = elem.result;
    //            var loginData = JSON.parse(text);

    //            var accessToken = <string>loginData.accessToken;
    //            this.storageService.set("tokenOAuth", accessToken);

    //        });
    //        // Start reading the blob as text.
    //        try {
    //            reader.readAsText(data.data);
    //        }
    //        catch {
    //            // fix IE11
    //            reader.readAsText(data.data);
    //        }
    //        this.firstTime = data.status == 200;
    //    }
    //    return data.status == 200;
    //}

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * parseLogIn
     * @param data
     * @returns
     */
    parseLogIn(data: any): boolean {
        ///*----------------------------------------------------------------------------------------------------*/console.log("login-service.ts : parseLogIn");
        ///*----------------------------------------------------------------------------------------------------*/console.log("login-service.ts : parseLogIn : data :", data);

        if (data.status == 200) {
            this.storageService.set("token", "temp");
            const reader = new FileReader();
            // This fires after the blob has been read/loaded.
            reader.addEventListener('loadend', (e) => {
                var elem = (<any>e.srcElement);
                if (elem == null) {
                    // Pour la version ESR de Firefox
                    elem = (<any>e.target);
                }
                const text = elem.result;
                var loginData = JSON.parse(text);
                ///*----------------------------------------------------------------------------------------------------*/console.log("login-service.ts : parseLogIn : JSON.parse(text) :", loginData);

                var temp = <string>loginData.token;
                this.storageService.set("token", temp);
                var role = <string>loginData.role;
                this.storageService.set("role", role);
                var CU = <string>loginData.unisiteCode;
                this.storageService.set("CU", CU);
                var isAttum = <string>loginData.isAttum;
                this.storageService.set("isAttum", isAttum);
                var country = <string>loginData.country;
                this.storageService.set("country", country);
                var haveGPI = <string>loginData.haveGPI;
                this.storageService.set("haveGPI", haveGPI);
                var haveCWI = <string>loginData.haveCWI;
                this.storageService.set("haveCWI", haveCWI);
                var accessToken = <string>loginData.accessToken;
                this.storageService.set("tokenOAuth", accessToken);

            });
            // Start reading the blob as text.
            try {
                reader.readAsText(data.data);
            }
            catch {
                // fix IE11
                reader.readAsText(data.data);
            }
            this.firstTime = data.status == 200;
        }
        return data.status == 200;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * isAuthenticated
     * @returns
     */
    public async isAuthenticated(): Promise<boolean> {
        ///*----------------------------------------------------------------------------------------------------*/console.log("login-service.ts : isAuthenticated");

        let token = this.storageService.get("token");   // Check whether the token is expired and return
        if (token == null) {
            this.router.navigate(['/login']);
            return null;
        }
        else if (token != "temp") {
            return true;
        }
        let counter = 0;
        await this.delay(50);
        token = this.storageService.get("token");
        if (token == "temp")
            this.router.navigate(['/login']);
        return token != "temp";

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * delay
     * @param ms
     * @returns
     */
    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    ///* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    ///**
    // * logOut
    // */
    //logOut() {
    //    //this.headerService.changeRole(Roles.Unknown);
    //    //sessionStorage.clear();
    //    this.router.navigate(["/login"]);
    //}

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * clearLogOut
     */
    clearLogOut() {

        this.headerService.changeRole(Roles.Unknown);
        sessionStorage.clear();
    }

}
